import { IonIcon, IonSpinner } from '@ionic/react';
import { alertCircle, checkmarkCircle } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import './SaveStatusIndicator.scss';

export type SaveStatus = 'idle' | 'saving' | 'saved' | 'error';

interface SaveStatusIndicatorProps {
  status: SaveStatus;
  errorMessage?: string;
  onRetry?: () => void;
}

export const SaveStatusIndicator: React.FC<SaveStatusIndicatorProps> = ({
  status,
  errorMessage,
  onRetry,
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (status === 'saving' || status === 'error') {
      setVisible(true);
    } else if (status === 'saved') {
      setVisible(true);
      // Auto-hide after 2 seconds
      const timer = setTimeout(() => {
        setVisible(false);
      }, 2000);
      return () => clearTimeout(timer);
    } else {
      setVisible(false);
    }
  }, [status]);

  if (!visible && status === 'idle') return null;

  return (
    <div
      className={`save-status-indicator ${status} ${visible ? 'visible' : ''}`}
    >
      {status === 'saving' && (
        <>
          <IonSpinner name="crescent" className="save-spinner" />
          <span className="save-text">Saving...</span>
        </>
      )}
      {status === 'saved' && (
        <>
          <IonIcon icon={checkmarkCircle} className="save-icon success" />
          <span className="save-text">Saved</span>
        </>
      )}
      {status === 'error' && (
        <>
          <IonIcon icon={alertCircle} className="save-icon error" />
          <span className="save-text">{errorMessage || 'Failed to save'}</span>
          {onRetry && (
            <button className="retry-button" onClick={onRetry}>
              Retry
            </button>
          )}
        </>
      )}
    </div>
  );
};
